import SmallCategoryScenario from '@/api/small_category/small_category/scenario.js';
import LanguageCodeEnum from '@/constants/category/language_code';

export const category = {
  strict: process.env.NODE_ENV === 'local',
  namespaced: true,
  state: {
    isLoading: false,
    categoryTree: null,
    categoryTreeForContractList: null,
    categoryTreeForSearchJoubun: null,
    checkContractLanguageCode: -1,
    lecheckTemplateLanguageCode: -1,
    userTemplateLanguageCode: -1
  },
  getters: {
    isLoading: (state) => state.isLoading,
    categoryTree: (state) => state.categoryTree,
    categoryTreeForContractList: (state) => state.categoryTreeForContractList,
    categoryTreeForSearchJoubun: (state) => state.categoryTreeForSearchJoubun,
    checkContractLanguageCode: (state) => state.checkContractLanguageCode,
    lecheckTemplateLanguageCode: (state) => state.lecheckTemplateLanguageCode,
    userTemplateLanguageCode: (state) => state.userTemplateLanguageCode
  },
  mutations: {
    setCategoryTree(state, categoryTree) {
      state.categoryTree = categoryTree;
      state.categoryTreeForContractList = JSON.parse(JSON.stringify(categoryTree));
      state.categoryTreeForSearchJoubun = JSON.parse(JSON.stringify(categoryTree));
    },
    setIsLoading(state, isLoading) {
      state.isLoading = isLoading;
    },
    setCheckContractLanguageCode(state, languageCode) {
      state.checkContractLanguageCode = languageCode;
    },
    setLecheckTemplateLanguageCode(state, languageCode) {
      state.lecheckTemplateLanguageCode = languageCode;
    },
    setUserTemplateLanguageCode(state, languageCode) {
      state.userTemplateLanguageCode = languageCode;
    },
    clear(state) {
      state.isLoading = false;
      state.categoryTree = null;
      state.categoryTreeForContractList = null;
      state.categoryTreeForSearchJoubun = null;
    }
  },
  actions: {
    async setCategoryTree({ commit, state }) {
      if (!state.categoryTree) {
        commit('setIsLoading', true);
        await SmallCategoryScenario.getCategoryTree()
          .then((res) => {
            commit('setCategoryTree', res.data.data);
          })
          .finally(() => {
            commit('setIsLoading', false);
          });
      }
    },
    async reloadCategoryTree({ commit }, smallCategoryId) {
      commit('setIsLoading', true);
      await SmallCategoryScenario.getCategoryTree()
        .then((res) => {
          let categoryTree = res.data.data;
          let languageCodeValueList = [LanguageCodeEnum.ja.value, LanguageCodeEnum.en.value];
          languageCodeValueList.forEach((languageCodeValue) => {
            categoryTree[languageCodeValue].forEach((category) => {
              const filteredSmallCategories = category.smallCategories.filter(
                (smallCategory) => smallCategory.smallCategoryId === smallCategoryId
              );
              if (filteredSmallCategories.length > 0) {
                category.bigCategory.isShowSmallCategories = true;
              }
            });
          });
          commit('setCategoryTree', categoryTree);
        })
        .finally(() => {
          commit('setIsLoading', false);
        });
    },
    clearCategoryTree({ commit }) {
      commit('clear');
    },
    setCheckContractLanguageCode({ commit }, languageCode) {
      commit('setCheckContractLanguageCode', languageCode);
    },
    setLecheckTemplateLanguageCode({ commit }, languageCode) {
      commit('setLecheckTemplateLanguageCode', languageCode);
    },
    setUserTemplateLanguageCode({ commit }, languageCode) {
      commit('setUserTemplateLanguageCode', languageCode);
    }
  }
};
